import { useState, useCallback } from 'react';

export const useConfirm = () => {
  const [confirmState, setConfirmState] = useState({
    isOpen: false,
    title: '',
    message: '',
    type: 'warning',
    confirmText: 'Confirmar',
    cancelText: 'Cancelar',
    onConfirm: null,
    loading: false
  });

  const confirm = useCallback(({
    title = 'Confirmar Acción',
    message = '¿Estás seguro de que quieres realizar esta acción?',
    type = 'warning',
    confirmText = 'Confirmar',
    cancelText = 'Cancelar',
    onConfirm = null
  }) => {
    return new Promise((resolve) => {
      setConfirmState({
        isOpen: true,
        title,
        message,
        type,
        confirmText,
        cancelText,
        onConfirm: async () => {
          if (onConfirm) {
            setConfirmState(prev => ({ ...prev, loading: true }));
            try {
              await onConfirm();
              resolve(true);
            } catch (error) {
              resolve(false);
            } finally {
              setConfirmState(prev => ({ ...prev, loading: false }));
            }
          } else {
            resolve(true);
          }
        }
      });
    });
  }, []);

  const closeConfirm = useCallback(() => {
    setConfirmState(prev => ({ ...prev, isOpen: false }));
  }, []);

  const setLoading = useCallback((loading) => {
    setConfirmState(prev => ({ ...prev, loading }));
  }, []);

  return {
    confirmState,
    confirm,
    closeConfirm,
    setLoading
  };
}; 